import app from '@/init'
import { buildFeedbackUrl } from '@/utils/feedbackUrl'

export function registerMessageClick(timestamp) {
  const domButton = document.getElementById(`el-message-button-${timestamp}`)
  const domText = document.getElementById(`el-message-text-${timestamp}`)

  domButton.addEventListener('click', () => {
    const errorText = domText.innerText

    jumpFeedback({ text: errorText })
  })
}

export function jumpFeedback(params) {
  try {
    const { locale } = app.$i18n
    const { text, screenshotPath } = params

    // 默认中文配置
    let FEEDBACK_URL = process.env.VUE_APP_FEEDBACK_URL
    let ERROR_MESSAGE = '报错信息'
    let PROCESS_LINK = '流程链接'
    let SCREENSHOT = '页面快照'

    // 英文配置
    if (locale === 'en') {
      FEEDBACK_URL = process.env.VUE_APP_FEEDBACK_URL_EN
      ERROR_MESSAGE = 'Error+message'
      PROCESS_LINK = 'Process+link'
    }

    // 构建基本URL参数
    let feedbackUrl = `${FEEDBACK_URL}?prefill_${ERROR_MESSAGE}=${encodeURIComponent(
      text
    )}&prefill_${PROCESS_LINK}=${encodeURIComponent(
      window.location.href
    )}&hide_${ERROR_MESSAGE}=1&hide_${PROCESS_LINK}=1`

    // 如果有截图信息，添加到URL中
    if (screenshotPath) {
      feedbackUrl += `&prefill_${SCREENSHOT}=${encodeURIComponent(
        screenshotPath
      )}&hide_${SCREENSHOT}=1`
    }

    window.open(feedbackUrl)
  } catch (error) {
    console.error('Error opening feedback page:', error)
  }
}
